import { ClassStudent } from '../context/types';

export const getDisplayName = (student: ClassStudent): string => {
    const hasFirstName = student.first_name && student.first_name !== '';
    const hasLastName = student.last_name && student.last_name !== '';
    const hasUserName = student.user_name && student.user_name !== '';

    if (hasFirstName && hasLastName) {
        return `${student.first_name} ${student.last_name}`;
    }

    if (hasFirstName && !hasUserName) {
        return student.first_name;
    }

    return student.user_name;
};
